/* Custom Afetiva — Detecta drawers abertos e scroll */
(function() {
  /* === Posiciona setas no centro da imagem ===
     Aplica so em carrosseis de colecao (collection-list, related, featured).
     Pula galeria de imagens do produto — ela usa layout proprio do Dawn. */
  function afetivaShouldCustomizeSlider(comp) {
    if (!comp) return false;
    if (comp.querySelector('.product__media-item')) return false;
    if (comp.querySelector('.thumbnail-list__item')) return false;
    return true;
  }
  function afetivaPositionSliderArrows(comp) {
    if (!comp) return;
    if (!afetivaShouldCustomizeSlider(comp)) return;
    var firstSlide = comp.querySelector('.slider > *');
    if (!firstSlide) return;
    var target = firstSlide.querySelector('.cl-explore-card__media, .card__media, .media--transparent, .media, picture, img') || firstSlide;
    var targetRect = target.getBoundingClientRect();
    if (targetRect.height < 20) return;
    var compRect = comp.getBoundingClientRect();
    var midY = targetRect.top - compRect.top + targetRect.height / 2;
    var btns = comp.querySelectorAll('.slider-button');
    for (var i = 0; i < btns.length; i++) {
      btns[i].style.top = midY + 'px';
      btns[i].style.transform = 'translateY(-50%)';
    }
    /* Observa mudanca de tamanho da imagem */
    if (!target.dataset.afetivaResizeObs && window.ResizeObserver) {
      target.dataset.afetivaResizeObs = 'true';
      var ro = new ResizeObserver(function() { afetivaPositionSliderArrows(comp); });
      ro.observe(target);
    }
  }
  function afetivaPositionAllSliderArrows() {
    var comps = document.querySelectorAll('slider-component');
    for (var i = 0; i < comps.length; i++) afetivaPositionSliderArrows(comps[i]);
  }
  var _afetivaSliderRAF = null;
  function afetivaSliderScheduleReposition() {
    if (_afetivaSliderRAF) return;
    _afetivaSliderRAF = requestAnimationFrame(function() {
      _afetivaSliderRAF = null;
      afetivaPositionAllSliderArrows();
    });
  }
  window.addEventListener('resize', afetivaSliderScheduleReposition, { passive: true });
  window.addEventListener('load', afetivaPositionAllSliderArrows);
  document.addEventListener('load', function(e) {
    if (e && e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('slider-component')) {
      afetivaSliderScheduleReposition();
    }
  }, true);
  /* Poll agressivo nos primeiros 3s */
  var _afetivaPollTimes = [100, 300, 600, 1000, 1500, 2200, 3000];
  _afetivaPollTimes.forEach(function(t) { setTimeout(afetivaPositionAllSliderArrows, t); });



  function isDrawerOpen() {
    if (document.querySelector('details[open] > .menu-drawer')) return true;
    if (document.querySelector('.menu-drawer-container[open]')) return true;
    if (document.querySelector('.menu-drawer.is-open')) return true;
    if (document.querySelector('cart-drawer.active')) return true;
    if (document.querySelector('cart-drawer[active]')) return true;
    if (document.querySelector('.cart-drawer.active')) return true;
    if (document.querySelector('.cart-drawer.is-open')) return true;
    return false;
  }

  function updateDrawer() {
    document.body.classList.toggle('afetiva-drawer-open', isDrawerOpen());
  }

  var obs = new MutationObserver(updateDrawer);
  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'active', 'aria-expanded']
  });

  updateDrawer();

  /* Scroll: esconde setas do slider quando rolar */
  var scrollThreshold = 80;
  function onScroll() {
    document.body.classList.toggle('afetiva-scrolled', window.scrollY > scrollThreshold);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Desabilita botao Adicionar ao carrinho se a variante selecionada nao existir
     ou estiver esgotada. Dawn atual expoe apenas a variante SELECIONADA no JSON
     do variant-radios (nao um array de todas), entao usamos o `available` dela direto. */
  var _allVariants = null;

  function loadAllVariants() {
    var pi = document.querySelector('product-info');
    var url = pi && pi.getAttribute('data-url');
    if (!url) return;
    fetch(url + '.js').then(function(r) { return r.json(); }).then(function(product) {
      if (product && Array.isArray(product.variants)) _allVariants = product.variants;
      updateAddButtonAvailability();
    }).catch(function() {});
  }

  function findVariantBySelectedOptions() {
    if (!_allVariants) return null;
    // So le fieldsets DENTRO de variant-radios/variant-selects (nao .product-form__input generico
    // que pode capturar options do Customily tambem)
    var selectedOptions = [];
    document.querySelectorAll(
      'variant-radios fieldset, variant-selects fieldset'
    ).forEach(function(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      var select = fs.querySelector('select');
      if (checked) selectedOptions.push(checked.value);
      else if (select) selectedOptions.push(select.value);
    });
    if (!selectedOptions.length) return null;
    return _allVariants.find(function(v) {
      var opts = [v.option1, v.option2, v.option3].filter(function(x) { return x != null; });
      if (opts.length !== selectedOptions.length) return false;
      return selectedOptions.every(function(sel, i) { return opts[i] === sel; });
    });
  }

  function readCurrentSelectedVariantFromDOM() {
    var jsonEl = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      var data = JSON.parse(jsonEl.textContent);
      // Formato antigo: array; novo: objeto
      if (Array.isArray(data)) return null;
      if (data && typeof data === 'object') return data;
    } catch (e) {}
    return null;
  }

  function hideNonExistentOptionValues() {
    if (!_allVariants) return;
    var fieldsets = document.querySelectorAll('variant-radios fieldset, variant-selects fieldset');
    if (!fieldsets.length) return;

    // Le opcoes atualmente selecionadas (na ordem dos fieldsets)
    var currentSelected = [];
    fieldsets.forEach(function(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      var select = fs.querySelector('select');
      if (checked) currentSelected.push(checked.value);
      else if (select) currentSelected.push(select.value);
      else currentSelected.push(null);
    });

    fieldsets.forEach(function(fs, fsIdx) {
      // Modelo (primeiro fieldset ou legend com "Modelo/Tipo/Estilo") NUNCA e filtrado.
      // Cor e Tamanho sao filtrados APENAS pelo Modelo (nao um pelo outro).
      var legend = fs.querySelector('legend, .form__label');
      var legendText = legend ? legend.textContent.trim() : '';
      var isModeloish = /modelo|tipo|estilo/i.test(legendText);
      if (fsIdx === 0 || isModeloish) return;

      var inputs = fs.querySelectorAll('input[type="radio"]');
      inputs.forEach(function(input) {
        // Existe se ha variante com Modelo (option[0]) atual + esse valor no fieldset fsIdx
        var exists = _allVariants.some(function(v) {
          var opts = [v.option1, v.option2, v.option3].filter(function(x) { return x != null; });
          if (currentSelected[0] !== null && opts[0] !== currentSelected[0]) return false;
          if (opts[fsIdx] !== input.value) return false;
          return true;
        });
        input.classList.toggle('afetiva-hidden-option', !exists);
        if (input.id) {
          var lbl = document.querySelector('label[for="' + input.id + '"]');
          if (lbl) lbl.classList.toggle('afetiva-hidden-option', !exists);
        }
      });

      // Selects (dropdowns) — mesma logica
      var select = fs.querySelector('select');
      if (select) {
        Array.prototype.forEach.call(select.options, function(opt) {
          var exists = _allVariants.some(function(v) {
            var vopts = [v.option1, v.option2, v.option3].filter(function(x) { return x != null; });
            if (currentSelected[0] !== null && vopts[0] !== currentSelected[0]) return false;
            if (vopts[fsIdx] !== opt.value) return false;
            return true;
          });
          opt.hidden = !exists;
          opt.disabled = !exists;
        });
      }
    });
  }

  function updateAddButtonAvailability() {
    // Se produto NAO tem variant pickers (has_only_default_variant), nao interfere
    var hasVariantPickers = document.querySelector('variant-radios, variant-selects');
    if (!hasVariantPickers) return;

    // Esconde valores que nao tem variante correspondente
    hideNonExistentOptionValues();

    var currentVariant;
    if (_allVariants) {
      currentVariant = findVariantBySelectedOptions();
    } else {
      currentVariant = readCurrentSelectedVariantFromDOM();
    }

    var unavailable = !currentVariant || currentVariant.available === false;

    // Body class controla visibilidade da customizacao Customily via CSS
    document.body.classList.toggle('afetiva-variant-unavailable', unavailable);

    document.querySelectorAll('.product-form__submit').forEach(function(btn) {
      // Guarda texto original na primeira vez (antes de sobrescrever)
      if (!btn.dataset.afetivaOriginalText) {
        var initial = btn.querySelector('span:not(.sold-out-message):not(.icon-loading)');
        if (initial && initial.textContent.trim() &&
            initial.textContent.trim() !== 'Esgotado') {
          btn.dataset.afetivaOriginalText = initial.textContent;
        }
      }
      var textSpan = btn.querySelector('span:not(.sold-out-message):not(.icon-loading)');
      if (unavailable) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        if (textSpan && textSpan.textContent !== 'Esgotado') {
          textSpan.textContent = 'Esgotado';
        }
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (textSpan && btn.dataset.afetivaOriginalText &&
            textSpan.textContent !== btn.dataset.afetivaOriginalText) {
          textSpan.textContent = btn.dataset.afetivaOriginalText;
        }
      }
    });
  }

  /* Quando Modelo (primeiro fieldset) muda e a selecao fica invalida/esgotada,
     auto-seleciona a primeira variante DISPONIVEL daquele Modelo — mantendo Cor
     atual se existir combo disponivel, senao pega qualquer combo disponivel. */
  function autoSelectFirstAvailableForModelo() {
    if (!_allVariants) return;
    var fieldsets = document.querySelectorAll('variant-radios fieldset, variant-selects fieldset');
    if (fieldsets.length < 2) return;

    var checked0 = fieldsets[0].querySelector('input[type="radio"]:checked');
    var modelo = checked0 ? checked0.value : null;
    if (!modelo) return;

    var currentSelected = [];
    fieldsets.forEach(function(fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      currentSelected.push(c ? c.value : null);
    });

    var allSelected = currentSelected.every(function(s) { return s != null; });
    if (allSelected) {
      var current = _allVariants.find(function(v) {
        var opts = [v.option1, v.option2, v.option3].filter(function(x) { return x != null; });
        if (opts.length !== currentSelected.length) return false;
        return currentSelected.every(function(s, i) { return opts[i] === s; });
      });
      if (current && current.available) return;
    }

    var currentCor = currentSelected[1];
    var firstAvail = null;
    if (currentCor) {
      firstAvail = _allVariants.find(function(v) {
        return v.option1 === modelo && v.option2 === currentCor && v.available;
      });
    }
    if (!firstAvail) {
      firstAvail = _allVariants.find(function(v) {
        return v.option1 === modelo && v.available;
      });
    }
    if (!firstAvail) return;

    for (var i = 1; i < fieldsets.length && i <= 2; i++) {
      var targetValue = firstAvail['option' + (i + 1)];
      if (!targetValue) continue;
      var input = Array.prototype.slice.call(fieldsets[i].querySelectorAll('input[type="radio"]'))
        .find(function(inp) { return inp.value === targetValue; });
      if (input && !input.checked) {
        var label = fieldsets[i].querySelector('label[for="' + input.id + '"]');
        if (label) label.click();
        else input.click();
      }
    }
  }

  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.closest) return;
    var container = e.target.closest('variant-radios, variant-selects, .product-form__input');
    if (!container) return;

    // Detecta se veio do PRIMEIRO fieldset (Modelo) — auto-seleciona Cor+Tamanho valido
    var changedFieldset = e.target.closest('fieldset');
    var allFieldsets = document.querySelectorAll('variant-radios fieldset, variant-selects fieldset');
    var isFirstFieldset = changedFieldset && allFieldsets[0] === changedFieldset;

    if (isFirstFieldset) {
      setTimeout(autoSelectFirstAvailableForModelo, 120);
    }
    setTimeout(updateAddButtonAvailability, 50);
  }, true);

  // Roda uma vez no load — busca lista completa de variantes e faz check inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      loadAllVariants();
      setTimeout(updateAddButtonAvailability, 500);
    });
  } else {
    loadAllVariants();
    setTimeout(updateAddButtonAvailability, 500);
  }
  // Re-aplica periodicamente pra combater re-render do Dawn
  setInterval(function() {
    if (_allVariants) updateAddButtonAvailability();
  }, 500);
})();
